{
  "bookingButtons": {
    "addFavJourneyButton": "Add Favorite Journey",
    "clearFavJourneyButton": "Clear Favorite Journey"
  },
  "newBooking": {
    "favJourneyCard": "Book Favorite Journey",
    "favJourneyEdit": "Edit Favorite Journey Description",
    "favJourneyClear": "Clear Favorite Journey"
  }
}
